const behaviorWithCats = [
    { value: 'friendly', label: { en: 'Friendly', es: 'Amistoso' } },
    { value: 'indifferent', label: { en: 'Indifferent', es: 'Indiferente' } },
    { value: 'curious', label: { en: 'Curious', es: 'Curioso' } },
    { value: 'fearful', label: { en: 'Fearful', es: 'Miedoso' } },
    { value: 'aggressive', label: { en: 'Aggressive', es: 'Agresivo' } },
    { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
];

export default behaviorWithCats;